'use client'

import { Media } from "@/components/Media";
import { Logo3Block as Logos3BlockType, Media as MediaProps } from "@/payload-types";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, FreeMode } from 'swiper/modules';
import 'swiper/css';
import './logo-3.css';

export const Logo3Block = (props: Logos3BlockType) => {
  const { heading, logos } = props;

  return (
    <section data-theme="light" className="bg-white overflow-hidden py-12 md:py-16 lg:py-20">
      <div className="container mb-8 w-full md:mb-10 lg:mb-12">
        <h1 className="text-center text-base font-extrabold leading-[1.2]  md:text-3xl  md:leading-[1.2]">
          {heading}
        </h1>
      </div>
      <div className="logo-carousel">
        {/* <Swiper
          className="logo-carousel__wrapper"
          wrapperClass="logo-carousel__inner-wrapper"
          spaceBetween={0}
          speed={5000}
          slidesPerView={1}
          freeMode={true}
          loop={true}
          autoplay={{
            delay: 0,
            disableOnInteraction: false,
          }}
          modules={[Autoplay, FreeMode]}
          breakpoints={{
            640: {
              slidesPerView: 2,
            },    
            768: {
              slidesPerView: 3,
            },
            1024: {
              slidesPerView: 5,
            },
          }}
        >
          {logos.map((logo: MediaProps) => (
            <SwiperSlide key={`logo-${logo.id}`} className="logo-carousel__item">
              <Media resource={logo} imgClassName="w-32 md:w-48" />
            </SwiperSlide>
          ))}
        </Swiper> */}
          

          <div className="flex flex-wrap justify-center gap-8 md:gap-12 lg:gap-16 px-4 md:px-6 lg:px-16">
            {logos.map((logo: MediaProps) => (
              <div key={`logo-${logo.id}`} className="">
                <Media resource={logo} imgClassName="h-16 md:h-18 w-auto mx-4" />
              </div>
            ))}
          </div>

      </div>
    </section>
  );
};
